/* eslint-disable */
const release = {
  "RELEASE_NOTES": "Notes et informations des versions",
  "ALL_RELEASE_DISPLAYED": "Toutes les informations disponibles sur les versions sont affichées",
  "ALL_RELEASE_NOTES": "Mises à jour",
  "LATEST_ESSENTIAL_FEATURES": "Dernières fonctionnalités essentielles",
  "ESSENTIAL_FEATURES": "Fonctionnalités essentielles",
  "STANDARD_FEATURES": "Fonctionnalités standards",
  "BUG_FIXES": "Corrections de bug",
  "MINOR_BUG_FIXES": "Corrections de bugs mineurs.",
  "DONT_SHOW_ESSENTIAL_AGAIN": "Ne plus afficher les nouveautés de la version actuelle",
  "DONT_SHOW_ANY_ESSENTIAL_AGAIN": "Ne plus afficher les nouveautés des prochaines versions",
  "SHOW_ALL_NOTES": "Afficher les informations de toutes les versions",
  "RELEASE_NOTES_SETTINGS_HINT": "Ces paramètres sont propres à cet appareil uniquement. Les paramètres peuvent être différent sur un autre appareil connecté sur le même compte.",
  "HIDE_CURRENT_ESSENTIAL_HINT": "En cochant cette option, les nouvelles fonctionnalités essentielles de la version actuelle ne s'afficheront plus lors du chargement de Shizen. Nous vous recommandons de cocher cette option si vous avez pris le temps de les lire.",
  "HIDE_ALL_ESSENTIAL_HINT": "En cochant cette option, les nouvelles fonctionnalités essentielles des nouvelles versions ne seront plus affichées lors du chargement de Shizen. Notez qu'une nouvelle version est publiée toutes les 1 ou 2 semaines. Nous vous recommandons de ne pas cocher cette option afin de tenir tout le monde informé des nouvelles fonctionnalités.",
  versions: [
    {
      version: '2.0.8',
      date: '2022-07-11',
      common: [
        {
          title: `Nous avons ajouté des boutons "plus" et "moins" dans les tournées terrain afin de saisir les indicateurs plus rapidement.`,
          description: `Ces boutons fonctionnent pour tous les indicateurs non-calculés.`,
        },
        {
          title: `Vous pouvez maintenant désélectionner un responsable d'action si vous l'avez ajouté par erreur.`,
          description: `Cliquez sur le responsable déjà sélectionné afin de le retirer.`,
        },
        {
          title: `Nous avons activé la saisie d'émojis dans la plupart des champs de texte sur Shizen.`,
          description: `N'hésitez pas à revenir vers nous pour nous donner votre avis.`,
        },
      ],
      bugs: [
        { title: `Correction de la saisie d'un indicateur calculé dans certains cas.` },
        { title: `Correction du chargement pour le widget "Texte par date".` },
        { title: `Correction de la zone de texte des notes amovibles.` },
        { title: `Correction du chargement des commentaires d'indicateur dans certains cas où le texte pouvait être très long.` },
        { title: `Correction de la modification des causes sur certains appareils mobiles.` },
      ],
    },
    {
      version: '2.0.4',
      date: '2022-06-19',
      common: [
        {
          title: `Shizen introduit les rôles d'utilisateur.`,
          description: `Certains accès peuvent maintenant être restreints par utilisateur depuis la config.`,
        },
      ],
      bugs: [
        { title: `Nous vous remercions d'avoir pris le temps de remonter le problèmes que vous avez détectés suite au nouveau design.<br>L'équipe a traité la majorité des problèmes mais certains nous ont peut-être échappé !<br>Si c'est le cas, utilisez le bouton "Signaler un bug" dans le menu de Shizen.` },
      ],
    },
    {
      version: '2.0',
      date: '2022-05-23',
      common: [
        {
          title: `Shizen a un nouveau design 🎁`,
        },
      ],
      bugs: [
      ],
    },
    {
      version: '1.7.49',
      date: '2022-04-25',
      common: [
        {
          title: `Il est désormais possible d'avoir un aperçu des fichiers Word et Excel depuis l'édition de fichier.`,
          description: `Il est possible que certaines options de style n'apparaissent pas dans l'aperçu.`,
        },
        {
          title: `Les archives des actions et problèmes peuvent être triées par date d'archivage.`,
          description: ``,
        },
        {
          title: `Les smartphones proposent maintenant une seule option plus accessible pour prendre une photo sur l'appareil.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage de la navigation de réunion sur un widget diaporama.` },
      ],
    },
    {
      version: '1.7.48',
      date: '2022-04-11',
      common: [
        {
          title: `Les archives des actions et des problèmes proposent maintenant les mêmes filtres que dans les pages Problèmes et Actions en attente.`,
          description: ``,
        },
        {
          title: `La page "Mon compte" propose maintenant un nouvel onglet : "@:message.MY_SENT_ACTIONS".`,
          description: ``,
        },
        {
          title: `L'export de problèmes vous donnera maintenant toutes les informations concernant les causes et les actions liées aux problèmes.`,
          description: ``,
        },
        {
          title: `Les tournées terrain terminées peuvent maintenant être exportées au format excel.`,
          description: ``,
        },
        {
          title: `Les administrateurs peuvent maintenant exporter la liste des utilisateurs au format excel.`,
          description: ``,
        },
        {
          title: `Un nouveau paramètre dans la config permet de désactiver la modification de tournées terrain terminées.`,
          description: ``,
        },
        {
          title: `Il est maintenant possible de réorganiser les lieux et les types de problèmes depuis la config.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage de l'éditeur de dates sur les petits écrans.` },
        { title: `Correction de l'application du filtre "Responsable" dans la liste des problèmes.` },
      ],
    },
    {
      version: '1.7.44',
      date: '2022-02-28',
      common: [],
      bugs: [
        { title: `Correction de l'affichage de la partie décimale de la valeur du jour dans les roues d'indicateur.` },
        { title: `Correction de l'affichage de la page des indicateurs lors de la modification d'un indicateur calculé.` },
      ],
    },
    {
      version: '1.7.43',
      date: '2022-02-14',
      common: [
        {
          title: `La recherche sur Shizen affichera maintenant jusqu'à 100 résultats dans chaque catégorie.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un bug bloquant l'indice de confiance d'un problème à 95%.` },
      ],
    },
    {
      version: '1.7.40',
      date: '2022-01-10',
      common: [
        {
          title: `Améliorations globales de performance.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage d'indicateurs hebdomadaires et mensuels dans une tournée terrain terminée.` },
        { title: `Correction de l'affichage de l'étape de la tournée terrain après validation.` },
        { title: `Correction de la configuration d'affichage lors de l'utilisation de valeurs cumulées croissantes.` },
        { title: `Correction de l'affichage de la valeur d'un indicateur calculé dans certains cas.` },
      ],
    },
    {
      version: '1.7.39',
      date: '2021-12-20',
      common: [
        {
          title: `Les statistiques des problèmes peuvent maintenant être filtrées par lieu et par type.`,
          description: `Ces filtres ont également été ajoutés aux widgets.`,
        },
        {
          title: `Lors de la création d'un nouvel indicateur, celui-ci sera automatiquement caché sur les pages où le thème entier est déjà caché.`,
          description: `Cela permet d'éviter aux équipes de modifier les paramètres des pages lorsqu'un thème ne doit pas apparaître.`,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage des informations dans les emails de notification.` },
        { title: `Correction de l'affichage du choix de responsable d'un problème.` },
        { title: `Correction de la fermeture d'assignation des plans d'action à une équipe.` },
        { title: `Correction de l'affichage de la page de management des problèmes.` },
      ],
    },
    {
      version: '1.7.38',
      date: '2021-12-13',
      common: [
        {
          title: `Le tableau du respect des plannings de tournées terrain peut maintenant être affiché en vue hebdo/mensuelle.`,
          description: `Selon la configuration d'affichage sélectionnée, les colonnes du tableau seront regroupées par semaine ou par mois. Si une tournée terrain n'a pas été effectuée durant la période, le point apparaîtra rouge.`,
        },
      ],
      bugs: [
        { title: `Correction de la sélection du responsable d'une action dans une fiche action affichée au sein d'une fiche problème.` },
      ],
    },
    {
      version: '1.7.37',
      date: '2021-12-06',
      common: [
        {
          title: `Les plans d'action peuvent être réordonnés depuis les paramètres.`,
          description: `L'ordre de vos colonnes de plan d'action sera le même que celui des plans dans les paramètres.`,
        },
        {
          title: `Le nom de l'auteur d'une information apparaît maintenant dans l'en-tête de celle-ci.`,
          description: ``,
        },
        {
          title: `Les informations peuvent être créées et modifiées à l'aide des options de formatage du texte (gras, italique, liste à puces, etc.).`,
          description: ``,
        },
        {
          title: `Les indicateurs statiques et incrémentaux peuvent maintenant être hebdomadaires ou mensuels.`,
          description: ``,
        },
        {
          title: `Nous avons ajouté le responsable d'un problème à l'exportation excel des problèmes.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de la hauteur des widgets qui pouvaient apparaître au-dessus de l'édition d'images.` },
        { title: `Correction de l'affichage de la fiche problème dans un widget diaporama.` },
      ],
    },
    {
      version: '1.7.35',
      date: '2021-11-22',
      common: [
        {
          title: `Nous introduisons dans Shizen une nouveauté pour les administrateurs : les plans d'action modèles.`,
          description: `L'objectif est le même que pour les modèles de réunions et de pages paramétrables : Permettre de créer des équipes plus rapidement avec un paramétrage de plus en plus complet.<br>Créez des plans d'action depuis la config, puis attribuez-les à vos équipes directement, ou depuis les modèles de démarrage.`,
        },
        {
          title: `Il est maintenant possible d'ajouter un commentaire à chaque item de checklist d'une tournée terrain.`,
          description: `Pour cela, cliquez sur l'icône commentaire sur la droite de l'item.`,
        },
        {
          title: `Nous avons ajouté une fenêtre de confirmation avant de retirer une checklist d'une étape lors de la modification d'une tournée terrain.`,
          description: `La fenêtre permet notamment d'accéder à la modification de la checklist.`,
        },
        {
          title: `Les widgets d'images peuvent maintenant être modifiés en dehors du paramétrage d'une page.`,
          description: `Vous devrez d'abord activer l'option du widget "@:message.WIDGET_PICTS_EDITABLE".`,
        },
      ],
      bugs: [
        { title: `Correction et retrait de l'item "Affichage" dans les options du dashboard.` },
        { title: `Correction et retrait du bouton "Modifier avant de démarrer" dans la liste des tournées terrain, lorsqu'elle est indisponible.` },
      ],
    },
    {
      version: '1.7.34',
      date: '2021-11-08',
      common: [
        {
          title: `Dupliquez vos widgets en un clic sur les pages paramétrables.`,
          description: `Cette nouvelle option vous permet de créer un widget identique à un autre. Après avoir dupliqué un widget, vous pouvez en modifier les paramètres.`,
        },
        {
          title: `Une nouvelle notification vous permet d'être alerté lorsqu'une personne commente un problème qui concerne votre équipe.`,
          description: `Vous pouvez également activer les emails pour cette notification depuis les paramètres > @:message.SETTINGS_MAIN > @:(message.NOTIFICATIONS).`,
        },
        {
          title: `Depuis le 5 Pourquoi et le diagramme d'Ishikawa, vous pouvez afficher les actions liées à une cause.`,
          description: `Vous pouvez également ajouter de nouvelles actions depuis la liste.`,
        },
      ],
      bugs: [
        { title: `Correction de l'export des problèmes.` },
        { title: `Correction de l'accès aux fichiers d'un problème partagé.` },
      ],
    },
    {
      version: '1.7.33',
      date: '2021-11-01',
      common: [
        {
          title: `Amélioration du champ de calcul d'un indicateur dans les paramètres.`,
          description: `Vous pouvez maintenant écrire au clavier dans le champ, déplacer le curseur et effacer en utilisant les touches "suppr." et "←".`,
        },
        {
          title: `Dans les informations, nous avons remplacé l'onglet "Eq suivies" par "@:message.SENT_INFOS_SHORT".`,
          description: `Cet onglet affiche maintenant la totalité des informations envoyées par votre équipe.`,
        },
      ],
      bugs: [
        { title: `Correction d'un bug lors de l'export d'une page paramétrable comme modèle.` },
        { title: `Correction des types et lieux dans l'export de la liste de problèmes.` },
      ],
    },
    {
      version: '1.7.32',
      date: '2021-10-25',
      essential: [
        {
          title: `Vous pouvez maintenant demander à Shizen de vous envoyer des notifications par email.`,
          description: `Vous pouvez personnaliser les types de notification que vous souhaitez recevoir depuis les paramètres, pour ne choisir que les plus importantes.`,
        },
      ],
      common: [
        {
          title: `Vous pouvez choisir d'afficher un indicateur en limitant l'ordonnée du graphique entre les valeurs minimale et maximale.`,
          description: `Ce paramètre est disponible pour chaque indicateur individuellement. Rendez-vous dans les paramètres des indicateurs, et cochez la case "@:message.INDIC_SETTINGS_ADAPTATIVE_RANGE".`,
        },
        {
          title: `Il est maintenant possible d'afficher le nombre d'actions en attente de l'équipe sur l'item du menu de navigation.`,
          description: `Pour cela, vous devez personnaliser votre menu dans les paramètres > @:message.SETTINGS_MAIN > @:(message.NAVIGATION_MENU). Créez une page pour les actions en attente et depuis les paramètres de la page, cochez la case "@:(message.DISPLAY_NUMBER_OF_ACTIONS_PENDING)".`,
        },
        {
          title: `Nous avons ajouté la possibilité de déterminer la moyenne d'indicateurs calculés.`,
          description: `Attention, si le calcul que vous entrez effectue déjà une moyenne (pourcentage, taux, ...), vous ne devez pas cocher cette option. Ce paramètre est similaire au calcul de la moyenne des indicateurs non calculés. Les valeurs seront divisées par le nombre de jours ouvrés.<br>Dans les paramètres de vos indicateurs calculés, si vous avez activé la fonction "@:message.CALC_AVERAGE", une nouvelle case vous sera proposée : "@:message.SETTINGS_INDIC_AVERAGE_AFTER_CALC".`,
        },
        {
          title: `Le widget de texte par date vous propose une nouvelle option pour naviguer par semaine ou par mois.`,
          description: ``,
        },
        {
          title: `Nous avons ajouté la possibilité d'effectuer un clic droit sur les appareils non tactiles.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de la position du curseur lors du clic sur un champ commentaire.` },
        { title: `Correction de la possibilité de dessiner avec deux doigts sur les appareils tactiles.` },
      ],
    },
    {
      version: '1.7.31',
      date: '2021-10-18',
      common: [
        {
          title: `La taille de la police des widgets texte peut maintenant être automatiquement ajustée à la taille du widget.`,
          description: `Une nouvelle option est disponible sur les widgets de texte pour que la taille du texte soit toujours ajustée au widget, quelle que soit sa taille. Vous pouvez notamment activer cette option lorsque la page est susceptible d'être affichée sur smartphone, tablette et grand écran.`,
        },
        {
          title: `"Chercher sur Shizen" affiche maintenant les images 20 par 20.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction des étapes de réunion qui avançaient 2 par 2.` },
        { title: `Correction du chargement infini lors de l'ajout d'un fichier.` },
        { title: `Correction de l'affichage des actions sur la page d'un indicateur détaillé.` },
        { title: `Correction de l'affichage des plannings de tournées terrain dans les statistiques de tournées terrain.` },
      ],
    },
    {
      version: '1.7.29',
      date: '2021-10-11',
      common: [
        {
          title: `Lorsque la barre de navigation de réunion est fermée, deux nouveaux boutons sont disponibles pour accéder à l'étape suivante et précédente.`,
          description: `Ces boutons ont la même fonction que les boutons visibles sur la barre d'origine.`,
        },
        {
          title: `Les actions peuvent être modifiées par les responsables même s'ils ne sont pas connectés à l'équipe propriétaire de l'action.`,
          description: `Auparavant, il était nécessaire de changer d'équipe pour modifier l'action.`,
        },
        {
          title: `L'équipe propriétaire d'un problème peut maintenant modifier les PDCA des actions d'autres équipes.`,
          description: `Auparavant, seule l'équipe chargée de l'action pouvait modifier le PDCA.`,
        },
        {
          title: `Dans un plan d'action, le clic sur une action filtrée permet d'accéder à la page de l'action.`,
          description: ``,
        },
        {
          title: `Sur tablette/smartphone, le champ de texte plein écran sera maintenant modifiable sans que l'utilisateur ait besoin de cliquer à nouveau.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de la synchronisation qui pouvait s'arrêter de manière inattendue.` },
        { title: `Correction de l'affichage des commentaires des indicateurs sur les pages paramétrables.` },
        { title: `Correction de l'affichage des commentaires d'indicateurs sur les roues mensuelles.` },
        { title: `Correction de l'édition du champ de texte des widgets de saisie par date, avec une connexion lente.` },
        { title: `Correction de la modification d'un commentaire d'indicateur depuis le widget diaporama sur tablette/smartphone.` },
      ],
    },
    {
      version: '1.7.28',
      date: '2021-10-04',
      common: [
        {
          title: `Ajout d'une trame par défaut pour le nouveau widget de saisie de texte.`,
          description: `Dans les options du widget, vous pouvez remplir un nouveau champ qui correspond au contenu par défaut du widget.`,
        },
        {
          title: `Il est maintenant possible de créer des actions depuis les outils "5 pourquoi" et Ishikawa.`,
          description: `Les actions créées de cette manière seront automatiquement liées aux causes depuis lesquelles elles sont ajoutées.`,
        },
        {
          title: `La date d'affichage des indicateurs peut maintenant être choisie sur un calendrier, en cliquant directement sur la date.`,
          description: `La date sélectionnée ainsi correspondra à la date de fin de la période. La date de départ sera automatiquement calculée en fonction.`,
        },
        {
          title: `Le motif de report de deadline peut maintenant être choisi dans la liste des anciens motifs.`,
          description: `Commencez à écrire dans le champ du motif de report pour filtrer la liste.`,
        },
        {
          title: `Le message d'avertissement paramétrable des indicateurs est maintenant visible sur les doughnuts.`,
          description: `Ces messages peuvent être modifiés depuis les paramètres des indicateurs.`,
        },
        {
          title: `Les indicateurs calculés peuvent maintenant être renseignés depuis la page d'une tournée terrain terminée.`,
          description: ``,
        },
        {
          title: `Les tournées terrain ont été optimisées pour les rendre plus fluides et plus efficaces.`,
          description: ``,
        },
        {
          title: `Ajout de l'heure en bas à gauche de la page.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de la fermeture impromptue du clavier sur les tablettes Windows lors de la modification du nom d'une action.` },
        { title: `Correction de la modification du champ "Objectif" dans les paramètres des indicateurs lorsque la connexion est lente.` },
        { title: `Correction de la modification de l'identifiant interne des utilisateurs.` },
      ],
    },
    {
      version: '1.7.27',
      date: '2021-09-20',
      common: [
        {
          title: `Les actions de la fiche problème peuvent maintenant être filtrées par étape du PDCA.`,
          description: `Pour ce faire, ouvrez le panneau bleu situé en haut de la colonne des actions.`,
        },
        {
          title: `Les indicateurs peuvent être exportés au format excel.`,
          description: `Les valeurs affichées dans le fichier excel seront celles affichées sur la page, quelle que soit la configuration sélectionnée.`,
        },
        {
          title: `Les participants à une tournée terrain sont maintenant disponibles depuis les tournées terminées.`,
          description: ``,
        },
        {
          title: `Lorsqu'une action est liée à un problème, les fichiers de l'action seront maintenant accessibles à toutes les équipes qui ont accès au problème.`,
          description: ``,
        },
        {
          title: `Le titre des pages paramétrables du menu peut maintenant être modifié.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un bug empêchant un utilisateur de se connecter après l'avoir changé d'équipe.` },
        { title: `Correction d'un bug empêchant de manipuler les notes amovibles situées en bas à gauche des pages paramétrables.` },
        { title: `Correction de l'affectation d'une action à de multiples plans supports.` },
        { title: `Correction de la modification d'un commentaire d'indicateur sur mobile.` },
        { title: `Correction du changement de période d'un indicateur dans la config.` },
        { title: `Correction de la modification de la couleur de fond des items du menu.` },
      ],
    },
    {
      version: '1.7.24',
      date: '2021-09-13',
      common: [
        {
          title: `Des options de tri sont maintenant disponibles dans les plans d'action et dans les actions du dashboard.`,
          description: `Ces options peuvent être pré-paramétrées dans les paramètres du menu de navigation.`,
        },
        {
          title: `Nouveau widget "Saisie de texte par date".`,
          description: `Ce widget vous permet de partager du texte et de l'enregistrer date par date. Il permet notamment d'avoir un historique de passage de consignes.`,
        },
        {
          title: `Le nom de l'utilisateur qui effectue une modification sur une fiche problème est maintenant affiché, ainsi que le nom de l'utilisateur qui crée un problème.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un bug affectant le démarrage d'une tournée terrain après avoir navigué entre plusieurs onglets.` },
        { title: `Correction du calcul de certains indicateurs qui pouvaient afficher des valeurs alors que des éléments du calcul manquaient.` },
        { title: `Correction d'affichage dans l'historique de la fiche problème.` },
      ],
    },
    {
      version: '1.7.23',
      date: '2021-08-30',
      bugs: [
        { title: `Correction de la création d'une nouvelle action.` },
        { title: `Correction de l'affichage des widgets indicateur lors du clic sur un commentaire.` },
        { title: `Correction de l'affichage des indicateurs du dashboard.` },
        { title: `Correction des flèches de navigation du widget diaporama.` },
      ],
    },
    {
      version: '1.7.22',
      date: '2021-08-23',
      common: [
        {
          title: `Les commentaires des indicateurs peuvent maintenant être formatés avec du gras, de l'italique, ...`,
          description: `D'autres options sont disponibles, comme les checklists, ou les listes à puce, par exemple.`,
        },
        {
          title: `Il est maintenant possible d'interagir avec le widget diaporama.`,
          description: `Si vous avez configuré le diaporama pour que les pages défilent automatiquement, vous perdrez votre progression à chaque changement de page.`,
        },
      ],
      bugs: [
        { title: `Correction du statut PDCA qui ne pouvait pas être modifié dans certains cas dans la fiche action.` },
        { title: `Correction du bouton de suppression des items des listes de vérification qui ne fonctionnait pas dans certains cas.` },
        { title: `Correction de l'affichage inattendu d'une fenêtre indiquant que le problème ne pouvait pas être modifié lors de l'ajout ou la suppression de fichiers.` },
      ],
    },
    {
      version: '1.7.21',
      date: '2021-07-26',
      bugs: [
        { title: `Correction de la sélection manuelle de période sur la page des indicateurs.` },
        { title: `Correction de la sélection du modèle d'indicateurs par défaut sur la page de management des indicateurs.` },
      ],
    },
    {
      version: '1.7.20',
      date: '2021-07-19',
      bugs: [
        { title: `Correction de l'affichage des pages paramétrables lors de la modification du pilote d'une action ou des fichiers des informations.` },
        { title: `Correction de la barre de recherche des utilisateurs dans la config.` },
        { title: `Correction des planifications de tournées terrain lors de l'utilisation de la copie depuis d'autres équipes.` },
        { title: `Correction du paramètre "moyenne" des indicateurs calculés.` },
      ],
    },
    {
      version: '1.7.19',
      date: '2021-07-12',
      common: [
        {
          title: `La sélection de période dans les statistiques de tournées terrain est maintenant la même que pour les indicateurs.`,
          requireGW: true,
          description: `Ce qui permet notamment de cumler les valeurs sur une période et afficher des données consolidées plus facilement.`,
        },
        {
          title: `Nous avons ajouté une nouvelle statistique sur le respect des plannings de tournées terrain, ainsi que son widget associé.`,
          requireGW: true,
          description: `L'affichage peut être sous forme d'un tableau ou d'un graphique.`,
        },
        {
          title: `Il est possible de sélectionner le texte dans les informations reçues.`,
          description: ``,
        },
        {
          title: `Nous avons rétabli le support pour la version 60 du navigateur Chrome`,
          description: `Lorsque cela est possible, Shizen vous recommande de mettre à jour votre navigateur dès qu'une nouvelle version est disponible. Avoir un navigateur à jour vous permettra de profiter de toutes les fonctionnalités de Shizen et évite un grand nombre de failles de sécurité.`,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage des indicateurs dans les pages de management et dans les pages paramétrables.` },
        { title: `Correction du bouton flottant dans la page des indicateurs.` },
        { title: `Correction de l'accès aux images des problèmes lorsqu'elles sont ajoutées par d'autres équipes.` },
        { title: `Correction de l'affichage des étapes d'une réunion.` },
      ],
    },
    {
      version: '1.7.17',
      date: '2021-06-07',
      essential: [
        {
          title: `Le champ "Décalage" sera bientôt retiré des widgets indicateurs.`,
          description: `Nous proposons maintenant une solution plus performante et pérenne pour gérer ces cas dans les configurations d'affichage des indicateurs. Par exemple, nous avons remplacé les widgets avec un décalage de 1 jour par une nouvelle configuration : "@:message.DAILY_INDICATORS_YESTERDAY_VALUE".<br>Vous pouvez en savoir plus dans les notes de la version 1.7.15.`,
        },
      ],
      common: [
        {
          title: `L'utilisateur qui a créé une action est maintenant affiché sur la page de l'action.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Stabilisation de la version 1.7.15.` },
        { title: `Correction de l'affichage des indicateurs dans la vue compacte.` },
        { title: `Correction de la suppression des commentaires de problèmes.` },
        { title: `Correction de l'avancement de la date sur la page des indicateurs dans certains cas.` },
        { title: `Correction de l'affichage de l'objectif du jour sur le dashboard dans la vue mensuelle.` },
      ],
    },
    {
      version: '1.7.15',
      date: '2021-05-31',
      essential: [
        {
          title: `Une cause d'un problème peut maintenant être définie comme 'Réelle', 'Fausse' ou 'Non vérifiée'.`,
          description: `Dans une résolution de problème, seules les causes réelles doivent être étudiées. Après analyse de la situation, si une cause a été déterminée comme fausse, l'équipe n'a plus besoin de travailler dessus.`,
        },
        {
          title: `Vous pouvez maintenant choisir d'afficher la semaine passée ou le mois précédent dans les configurations d'affichage des indicateurs.`,
          description: `Les configurations d'affichage des indicateurs peuvent maintenant ête définies relativement à la journée en cours. Rendez-vous dans les configurations d'affichage des indicateurs, dans la section "@:message.IDC_END_DATE" et choisissez "@:message.IDC_CURRENT_DATE_GAP".<br>Par exemple, pour afficher la semaine précédente, entrez "1 Semaine".`,
        },
        {
          title: `Les widgets des pages paramétrables peuvent maintenant être placés et alignés sur une grille.`,
          description: `Deux modes d'alignement possibles des widgets : Les uns aux autres ou sur une grille.`,
        },
      ],
      common: [
        {
          title: `Ajout de la fonction "Souligner" et d'une fonctionnalité permettant de coller des liens hypertexte dans les commentaires d'une action.`,
          description: `Vous pouvez maintenant afficher du texte souligné et créer des liens cliquables et copiant-collant une adresse URL dans le champ.`,
        },
        {
          title: `Ajout d'un bouton Archiver/Restaurer dans la fiche problème, dans le panneau de droite.`,
          description: ``,
        },
        {
          title: `"Résolution terminée" devient "Actions terminées" dans les statuts des problèmes.`,
          description: ``,
        },
        {
          title: `Un problème passera maintenant au statut "Actions en cours" seulement si une action a démarré.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage des widgets dans les pages paramétrables.` },
        { title: `Correction de l'affichage de l'avancement des actions en cours dans les plans d'action lorsque l'appareil a un léger décalage horaire.` },
        { title: `Correction de l'affichage des commentaires d'un indicateur après avoir coché "@:message.INDIC_SETTINGS_DISPLAY_CALC_COMMENTS".` },
      ],
    },
    {
      version: '1.7.14',
      date: '2021-05-24',
      common: [
        {
          title: `Le champ "Commentaires" de la page de modification d'une action propose quelques nouveautés de mise en forme.`,
          description: `Vous pouvez maintenant écrire du texte en gras ou en italique, utiliser des listes à puces ou des checklists, etc. N'hésitez pas à nous faire vos retours !`,
        },
        {
          title: `La page des statistiques propose quelques options d'affichage supplémentaires.`,
          description: `Vous pouvez filtrer les stats concernant les problèmes, ou encore afficher les valeurs des points des graphes.`,
        },
        {
          title: `Vous pouvez remplir votre adresse email et votre numéro de téléphone lorsque vous remontez un bug à Shizen.`,
          description: `Cela permet au personnel technique de communiquer plus rapidement avec vous au besoin.`,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage des manuels utilisateur.` },
      ],
    },
    {
      version: '1.7.13',
      date: '2021-05-17',
      common: [
        {
          title: `La page actions propose maintenant une nouvelle option pour afficher uniquement certains plans d'action.`,
          description: ``,
        },
        {
          title: `Nous avons amélioré le comportement des reports de deadline des actions et problèmes.`,
          description: ``,
        },
        {
          title: `Amélioration visuelle de la section indicateurs du dashboard.`,
          description: ``,
        },
        {
          title: `Vous retrouverez maintenant un manuel d'utilisateur sur la plupart des pages de Shizen.`,
          description: ``,
        },
        {
          title: `Vous avez la possibilité de coller une image depuis le presse-papiers lors de l'import d'un fichier.`,
          description: ``,
        },
        {
          title: `La config affiche maintenant le nombre d'utilisateurs et d'équipes.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un bug lors de l'importation d'un indicateur public dans un thème de tournées terrain.` },
        { title: `Correction d'un bug permettant à un administrateur de se supprimer lui-même de la config.` },
      ],
    },
    {
      version: '1.7.9',
      date: '2021-04-12',
      common: [
        {
          title: `Les options d'affichage des indicateurs contiennent maintenant une option de "date fixe" pour figer l'affichage d'un indicateur.`,
          description: `Par exemple, si vous souhaitez que vos graphes affichent toujours le mois d'août 2020, rendez-vous dans la configuraiton d'affichage, sélectionnez "1 mois" pour les périodes de point et de graphe, cochez la case "@:message.IDC_FIXED_END_DATE" et choisissez la date du 31 août 2020.`,
        },
        {
          title: `D'ailleurs, les options d'affichage d'indicateurs sont maintenant également modifiables depuis les paramètres lorsque vous modifiez les options d'une page d'indicateurs.`,
          description: ``,
        },
        {
          title: `Le bouton de signalement de bugs a été réduit sur les smartphones et petites tablettes.`,
          description: ``,
        },
        {
          title: `Les indicateurs de tournées terrain ont été retirés des options "Cacher des indicateurs".`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un bug qui faisait apparaître une mauvaise durée d'étape de tournée terrain.` },
        { title: `Correction d'un bug d'édition des détails d'un utilisateur.` },
        { title: `Correction d'un bug d'affichage où les boutons d'enregistrement aparaissaient au mauvais endroit sur la page de création de problème.` },
        { title: `Correction de l'affichage de la première valeur des indicateurs hebdomadaires sur la page d'indicateurs du management.` },
      ],
    },
    {
      version: '1.7.8',
      date: '2021-04-05',
      common: [
        {
          title: `Lors de la modification d'un indicateur d'une autre équipe, le nom de cette équipe est maintenant affiché.`,
          description: ``,
        },
        {
          title: `L'administrateur peut maintenant activer une option pour autoriser l'envoi d'informations à n'importe quelle autre équipe.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction du champ "commentaire" des indicateurs dans une tournée terrain.` },
        { title: `Correction des paramètres de zones d'une page problème qui pouvait apparaître décochés.` },
        { title: `Correction d'un bug qui pouvait faire appparaître certains éléments du menu en double.` },
      ],
    },
    {
      version: '1.7.7',
      date: '2021-03-29',
      common: [
        {
          title: `Nouvelle statistique sur le nombre de reports d'actions, dans la page statistiques.`,
          description: ``,
        },
      ],
    },
    {
      version: '1.7.6',
      date: '2021-03-22',
      common: [
        {
          title: `Vous pouvez maintenant créer des réunions à appliquer à plusieurs équipes depuis la config.`,
          description: ``,
        },
        {
          title: `Nous avons retiré le bouton "Enregistrer" dans les paramètres de réunions.`,
          description: `Lorsque vous effectuerez une modification dans vos réunions, les paramètres seront automatiquement enregistrés.`,
        },
        {
          title: `L'option d'affichage des indicateurs peut être paramétrée par défaut dans le paramétrage du menu.`,
          description: ``,
        },
        {
          title: `Dans les indicateurs calculés, les valeurs non renseignées sont maintenant remplacées par 0 lorsque cela est possible.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'un problème sur les zones de texte sur Firefox.` },
        { title: `Correction d'un problème qui empêchait d'ordonner correctement les indicateurs.` },
        { title: `Correction d'un bug qui empêchait d'ajouter des images et des documents aux widgets.` },
        { title: `Correction d'un problème qui pouvait effacer une partie du texte entré dans les commentaires des indicateurs.` },
      ],
    },
    {
      version: '1.7.5',
      date: '2021-03-15',
      common: [
        {
          title: `Les pages paramétrables peuvent maintenant être standardisées dans la société.`,
          description: `L'administrateur de Shizen peut maintenant créer des pages paramétrables qu'il peut diffuser dans plusieurs équipes simultanément.<br>
Il peut également décider de synchroniser ces pages afin de les modifier en quelques clics.`,
        },
      ],
      bugs: [
        { title: `Correction du problème de disparition des actions dans la fiche problème.` },
        { title: `Correction de la taille de la zone commentaire dans l'édition d'un indicateur.` },
        { title: `Correction d'un problème pouvant affecter l'envoi d'action ou de problème à d'autres équipes.` },
        { title: `Correction d'un problème qui empêchait le bon affichage de la liste des tournées terrain terminées.` },
        { title: `Correction du nombre d'indicateurs cachés dans les pages d'indicateurs.` },
      ],
    },
    {
      version: '1.7.4',
      date: '2021-03-08',
      essential: [
        {
          requireGW: true,
          title: `Le paramétrage de vos tournées terrain a été largement simplifié.`,
          description: `Les listes de vérification peuvent être créées et modifiées depuis la page de création d'une tournée terrain. Les listes et les indicateurs de tournées terrain sont dupliqués automatiquement lorsque vous dupliquez une tournée terrain.`,
        },
      ],
      common: [
        {
          title: `Les commentaires des indicateurs utilisés dans un calcul peuvent maintenant être affichés à la place des commentaires normaux.`,
          description: `Depuis les paramètres d'un indicateur calculé, cochez la case "@:message.INDIC_SETTINGS_DISPLAY_CALC_COMMENTS".`,
        },
        {
          title: `Le calcul des indicateurs calculés peut maintenant faire intervenir des indicateurs d'autres équipes.`,
          description: `Depuis les paramètres d'un indicateur calculé, sélectionnez "@:message.INDICATOR_OF_OTHER_TEAM".`,
        },
      ],
      bugs: [
        { title: `Correction d'un problème lors de l'utilisation des boutons + et - dans le changement de valeur d'un indicateur.` },
        { title: `Correction d'un problème qui empêchait d'utiliser un indicateur calculé.` },
      ],
    },
    {
      version: '1.7.0',
      date: '2021-02-08',
      essential: [
        {
          requireGW: true,
          title: `Améliorations des indicateurs de tournées terrain.`,
          description: `Nous apportons plusieurs améliorations au fonctionnement des indicateurs de tournées terrain.<br><br>\
Le comportement de ces indicateurs est maintenant plus proche du fonctionnement des indicateurs de performance classiques. D'ailleurs, nous venons de déplacer vos indicateurs de tournées terrain dans les paramètres d'indicateurs.<br><br>\
Avec cette mise à jour, vous pourrez observer plus en détails vos indicateurs de tournées terrain de la même manière que les indicateurs actuels. Par défaut, les indicateurs de tournées terrain n'apparaissent pas dans vos pages d'indicateurs mais vous pouvez ajouter ces indicateurs dans les pages paramétrables, ainsi que dans les calculs de vos indicateurs calculés.<br>\
De plus, les prochaines mises à jour apporteront davantage de facilité pour le paramétrage de vos tours de terrain.`,
        },
      ],
      common: [
      ],
    },
    {
      version: '1.6.8',
      date: '2021-01-25',
      common: [
        {
          title: `Vous retrouverez maintenant toutes les tournées terrain effectuées par votre équipe dans la liste des tournées terrain terminées.`,
          description: `Certaines tournées terrain ne s'affichaient pas si elles avaient été créées à partir des modèles d'autres équipes.`,
        },
        {
          title: `Les informations peuvent être envoyées à toutes les équipes auxquelles votre équipe a accès.`,
          description: `Avant la mise à jour, vous ne pouviez envoyer des informations qu'aux équipes du niveau hiérarchique d'en-dessous.`,
        },
        {
          title: `Davantage d'informations sont disponibles sur les bugs et améliorations que vous avez remontés à Shizen.`,
          description: `Les pièces jointes et les commentaires sont maintenant visibles.`,
        },
      ],
    },
    {
      version: '1.6.7',
      date: '2021-01-11',
      common: [
        {
          title: `La page des modèles de tournées terrain affiche maintenant les tournées terrain séparées par équipe.`,
          description: `Pour retrouver les tournées terrain des autres équipes, ouvrez les options sur la gauche de la page. Vous pouvez également paramétrer la page dans les paramètres pour n'afficher que les tournées de votre équipe. @:message.SETTINGS > @:message.SETTINGS_MAIN > @:message.NAVIGATION_MENU.`,
        },
      ],
    },
    {
      version: '1.6.6',
      date: '2021-01-04',
      common: [
        {
          title: `Il est maintenant possible de personnaliser l'organigramme des équipes depuis l'accès administrateur.`,
          description: `Depuis l'accès administrateur, 2 nouveaux paramètres sont disponibles : "@:message.SUPERVISED_TEAMS" et "@:message.SUPERVISOR_TEAMS". L'organigramme a été uniformisé pour être affiché dans l'ensemble de Shizen, y compris lors de l'envoi d'un problème, d'une action ou d'une information à une autre équipe.`,
        },
      ],
      bugs: [
        { title: `Correction d'un problème d'affichage sur les indicateurs publics incrémentaux.` },
        { title: `Correction de problèmes mineurs dans les pages paramétrables.` },
        { title: `Correction d'un problème lors du lancement d'une réunion si celle-ci comprend des comptes utilisateurs désactivés.` },
      ],
    },
    {
      version: '1.6.5',
      date: '2020-12-21',
      common: [
        {
          title: `Davantage d'informations sont disponibles dans les messages automatiques d'information des tournées terrain.`,
          description: ``,
        },
        {
          title: `Le partage d'un problème se fait maintenant depuis la colonne "Problème" de la fiche problème.`,
          description: ``,
        },
        {
          title: `L'ordre des informations dans l'historique de la fiche problème a été inversé.`,
          description: ``,
        },
      ],
      bugs: [
        { title: `Correction d'erreurs d'affichage dans les paramètres.` },
        { title: `Correction de problèmes d'affichage dans les tournées terrain terminées.` },
        { title: `Correction d'un problème d'envoi d'email dans la config.` },
      ],
    },
    {
      version: '1.6.4',
      date: '2020-12-07',
      common: [
        {
          title: `Vous pouvez choisir jusqu'à 3 lettres pour vos thèmes d'indicateurs.`,
          description: `Pour les modifier, rendez-vous dans les @:message.SETTINGS > @:message.SETTINGS_INDICATORS > @:(message.SETTINGS_INDICATORS_THEMES).`,
        },
        {
          title: `Ajout d'un bouton, au sein de la fiche problème, pour afficher et modifier tous les détails d'une action.`,
          description: `Dans la colonne "Actions" de la fiche problème, ouvrez une action, et cliquez sur @:(message.ACTION_SHEET).`,
        },
        {
          title: `Les post-its peuvent maintenant afficher des sauts de ligne.`,
          description: ``,
        },
        {
          title: `Ajout de la compatibilité SAML et Google SSO.`,
          description: ``,
        },
      ],
    },
    {
      version: '1.6.3',
      date: '2020-11-30',
      common: [
        {
          title: `Vous pouvez maintenant changer la page d'accueil par défaut.`,
          description: `Si le dashboard ne répond pas à vos besoins, vous pouvez changer la page d'accueil depuis les @:message.SETTINGS > @:message.SETTINGS_MAIN > @:(message.DEFAULT_HOME_PAGE). Vous bénéficierez toujours d'un accès au dashboard depuis le menu.`,
        },
        {
          title: `Il est maintenant possible de lier une action à un indicateur.`,
          description: `À l'instar des problèmes, les actions peuvent être liées aux indicateurs depuis la page d'édition d'une action. Si un problème est lié à un indicateur, ses actions seront également liées aux mêmes indicateurs par défaut.`,
        },
        {
          title: `Affichage des personnes responsables des tournées terrain.`,
          description: `Si une personne est connectée à son compte personnel, son nom apparaîtra dans la liste des tournées terrain terminées qu'elle a réalisées.`,
        },
        {
          title: `La date de fin d'une information a été modifiée au lendemain de la date de publication par défaut.`,
          description: `Avant la mise à jour, la date de fin était une semaine après la publication.`,
        },
      ],
      bugs: [
        { title: `Correction d'un problème empêchant la modification d'un objectif d'un indicateur.` },
        { title: `Les actions de sécurisation ne peuvent plus être ajoutées aux plans d'action.` },
      ],
    },
    {
      version: '1.6.1',
      date: '2020-11-16',
      common: [
        {
          beta: `@:message.BETA_SSO_LOGIN.`,
          title: `La connexion par SSO (Single Sign On) est disponible.`,
          description: `Lorsque les administrateurs de votre compte Shizen l'auront paramétrée, vous pourrez vous connecter à Shizen en sélectionnant l'option "@:message.LOGIN_BY_SSO" depuis la page de connexion. .`,
        },
      ],
    },
    {
      version: '1.6.0',
      date: '2020-11-09',
      common: [
        {
          title: `La connexion par compte utilisateur personnel est maintenant disponible.`,
          description: `Lorsque les administrateurs de votre compte Shizen auront paramétré votre compte utilisateur, vous recevrez un email contenant un identifiant et un nouveau mot de passe temporaire. Vous pourrez alors vous connecter à Shizen en sélectionnant l'option "@:message.LOGIN_BY_USER" depuis la page de connexion.`,
        },
        {
          title: `Le chargement des listes de vérification des tournées a été grandement amélioré.`,
          description: `Le chargement pouvait prendre un certain temps avec un grand nombre de checklists.`,
        },
      ],
      bugs: [
        { title: `Correction de l'affichage des actions dans la page d'indicateur détaillé et dans les pages paramétrables.` },
      ],
    },
    {
      version: '1.5.5',
      date: '2020-10-19',
      common: [
        {
          title: `Les indicateurs publics sont maintenant actualisés dès qu'une de leurs valeurs est modifiée.`,
          description: '',
        },
        {
          title: `La recherche de problèmes et d'actions a été améliorée.`,
          description: '',
        },
        {
          title: `Les graphes des indicateurs cumulés peuvent maintenant être des histogrammes.`,
          description: '',
        },
        {
          title: `Le clic sur une valeur d'un indicateur n'affichera plus la fenêtre contextuelle si aucun commentaire n'est présent pour cette valeur.`,
          description: '',
        },
      ],
      bugs: [
        { title: `Correction de la mise à jour des indicateurs incrémentaux le lendemain d'une nouvelle valeur.` },
        { title: `Correction des items du menu qui pouvaient être affichés sur la page.` },
        { title: `La barre de recherche a été supprimée de l'affichage smartphone.` },
      ],
    },
    {
      version: '1.5.4',
      date: '2020-10-12',
      common: [
        {
          title: `Les informations peuvent être triées comme vous le souhaitez.`,
          description: `Le tri fonctionne dans la page des informations ainsi que dans le dashboard.<br>Pour avoir une page triée par défaut, accédez aux @:message.SETTINGS > @:message.SETTINGS_MAIN > @:message.NAVIGATION_MENU puis cliquez sur "@:message.CHOOSE_SETTINGS" pour les pages Dashboard ou Informations.`,
        },
      ],
      bugs: [
        { title: `Correction de la modification des notes amovibles dans les "5 pourquoi" et les pages paramétrables sur certains appareils.` },
        { title: `Correction de l'affichage des bulles des indicateurs.` },
        { title: `Correction de l'affichage des indicateurs lors de l'ajout d'une valeur "infinie".` },
        { title: `Correction de l'objectif des indicateurs publics dans certains cas.` },
        { title: `Correction du nombre de problèmes terminés dans les statistiques.` },
      ],
    },
    {
      version: '1.5.3',
      date: '2020-10-05',
      common: [
        { title: `Vous pouvez à présent cliquer sur les points des graphes pour agrandir la bulle de commentaires.` },
      ],
      bugs: [
        { title: `Correction de l'édition des causes de l'ishikawa sur les appareils mobiles.` },
      ],
    },
    {
      version: '1.5.2',
      date: '2020-09-28',
      common: [
        {
          title: `Personnalisez le curseur de l'impact d'un problème en y ajoutant des annotations personnalisées.`,
          description: `@:message.SETTINGS > @:message.SETTINGS_PROBLEMS > @:message.CUSTOM_PROBLEM_HINTS.`,
        },
        {
          title: `Nouveau paramétrage possible pour la page "Management > Indicateurs" dans le menu de navigation.`,
          description: `Vous pouvez maintenant définir la vue par défaut et les équipes sélectionnées et vous rendant dans les @:message.SETTINGS > @:message.SETTINGS_MAIN > @:message.NAVIGATION_MENU.`,
        },
        {
          title: `Améliorations globales des performances.`,
          description: '',
        },
      ],
      bugs: [
        { title: `Correction des nombres de problèmes en cours et terminés dans les statistiques.` },
        { title: `Correction d'un problème lors de l'utilisation du paramètre "Moyenne" pour un indicateur public.` },
      ],
    },
    {
      version: '1.5.1',
      date: '2020-09-21',
      essential: [
        {
          title: `Vous avez maintenant la possibilité de personnaliser les indications des champs de remontée de problème.`,
          description: `Vous pouvez également choisir d'afficher ces indications dans la fiche problème. Pour essayer, rendez-vous dans les @:message.SETTINGS > @:message.SETTINGS_PROBLEMS > @:message.CUSTOM_PROBLEM_HINTS.`,
        },
      ],
      common: [
        {
          title: `Ajout d'une icône sur les causes de la fiche problème pour les désélectionner plus facilement.`,
          description: `La cause pouvait être difficile à sélectionner/désélectionner lorsqu'elle contenait plusieurs lignes de texte. L'aide de la page a été mise à jour.`,
        },
        {
          title: `Les cercles rouges et verts dans la vue "compacte" des indicateurs de management sont maintenant des diagrammes circulaires.`,
          description: `Les cercles affichent maintenant la répartition des valeurs (dans l'objectif, en écart, valeur non renseignée).`,
        },
      ],
      bugs: [
        { title: `L'affichage de valeurs croissantes des indicateurs affichait "0" lorsqu'il n'y avait pas de valeur.` },
        { title: `Correction du calcul d'indicateurs avec certains indicateurs publics.` },
        { title: `Correction de problèmes d'affichages dans le dashboard et les pages d'indicateurs.` },
      ],
    },
    {
      version: '1.5.0',
      date: '2020-09-14',
      essential: [
        {
          beta: `@:message.BETA_CALCULATED_INDIC.`,
          title: `Créez des indicateurs calculés ! 💹.`,
          description: `La version beta des indicateurs calculés est maintenant disponible. Rendez-vous dans les paramètres des indicateurs pour créer des indicateurs qui se rempliront automatiquement.`,
        },
      ],
      common: [
        {
          title: `Ajout des sauts de ligne dans l'édition des commentaires d'une action.`,
          description: `Vous pourrez maintenant sauter des lignes dans le champ "Commentaires" d'une action.`,
        },
      ],
      bugs: [
        {
          title: `Correction de la langue dans le calendrier d'édition des dates.`,
        },
      ],
    },
    {
      version: '1.4.2',
      date: '2020-09-06',
      bugs: [
        {
          title: `Correction de la légende et de l'affichage des indicateurs cumulés.`,
        },
        {
          title: `Correction d'affichage dans les plans d'action et les indicateurs.`,
        },
      ],
    },
    {
      version: '1.4.0',
      date: '2020-06-29',
      essential: [
        {
          title: `Les actions de sécurisation peuvent maintenant être affichées depuis la page des actions en cours.`,
          description: `Pour modifier la page par défaut, rendez-vous dans les @:message.SETTINGS > @:message.SETTINGS_MAIN > @:message.NAVIGATION_MENU, puis cliquez sur "@:message.CHOOSE_SETTINGS" pour la page "Actions".`,
        },
        {
          title: `Les widgets "indicateur" permettent d'afficher des valeurs cumulées de la même manière que l'indicateur détaillé.`,
          description: `Rendez-vous sur une page paramétrable, placez un widget "indicateur" sur la page, cliquez sur l'indicateur pour afficher les options, puis cliquez sur "@:message.CUSTOM_DISPLAY" et choisissez une configuration permettant le cumul des valeurs.`,
        },
        {
          title: `La vitesse de chargement des indicateurs a été améliorée et un logo de chargement est maintenant affiché lorsque Shizen met à jour les valeurs des indicateurs.`,
          description: '',
        },
      ],
      common: [
        {
          title: `Les informations peuvent maintenant être modifiées depuis le dashboard.`,
          description: `À condition d'avoir activer la fonctionnalité depuis @:message.SETTINGS > @:message.SETTINGS_DASHBOARD > @:message.DISPLAY > @:(message.SETTINGS_DISPLAY_CURRENT_INFOS).`,
        },
        {
          title: `Les valeurs d'indicateurs statiques et incrémentaux peuvent être supprimées.`,
          description: `La suppression d'une valeur d'indicateur statique entraînera une interruption des valeurs sur le graphe.`,
        },
      ],
      bugs: [
        {
          title: `Correction de l'affichage des commentaires sur les graphes des indicateurs.`,
        },
        {
          title: `Correction de l'affichage de la période des widgets indicateur lors de l'utilisation de configurations personnalisées.`,
        },
        {
          title: `Correction du tri dans la liste des tournées terrain terminées qui pouvait être incohérent dans certains cas.`,
        },
        {
          title: `Correction de l'affichage de l'objectif dans l'indicateur détaillé et la saisie de valeur.`,
        },
        {
          title: `Correction de l'agenda: certains évènements pouvaient être décalés d'un jour.`,
        },
      ],
    },
    {
      version: '1.3.64',
      date: '2020-06-22',
      common: [
        {
          title: 'Nouvelles options d\'affichages disponibles pour les indicateurs: périodes et valeurs',
          description: 'Vous pouvez maintenant afficher les périodes concernées et les valeurs des points sur vos graphes. Apprenez-en plus en vous rendant dans les @:message.SETTINGS > @:message.SETTINGS_INDICATORS > @:message.INDIC_SETTINGS_CHARTS_DISPLAY',
        },
      ],
    },
    {
      version: '1.3.60',
      date: '2020-06-01',
      common: [
        {
          title: 'Message encourageant les utilisateurs à remonter un problème lorsqu\'un indicateur est hors objectif',
          description: 'Cette fonctionnalité peut être désactivée depuis les @:message.SETTINGS > @:message.SETTINGS_INDICATORS > @:message.DISPLAY_NEO_HINTS',
        },
        {
          title: 'Ajout des types et des lieux dans la recherche de problèmes similaires',
          description: 'Deux problèmes liés aux mêmes lieux ou aux mêmes types auront un score de similarité plus élevé dans la recherche de problèmes similaires.',
        },
        {
          title: 'Ajout d\'un pareto sur la récurrence des problèmes dans la page des statistiques',
          description: '',
        },
      ],
      bugs: [
        {
          title: 'Correction des problèmes d\'affichage de la page des indicateurs.',
          description: ''
        },
        {
          title: 'Correction d\'un bug qui provoquait l\'affichage d\'objectifs erronés dans la page des indicateurs.',
          description: '',
        },
        {
          title: '@:message.DETAILED_INDICATOR : Correction du widget des pages paramétrables.',
          description: 'L\'analyse pouvait ne pas s\'afficher correctement dans certains cas.',
        },
        {
          title: '@:message.DETAILED_INDICATOR : Correction du décalage entre les valeurs ciblés sur le graphe du haut de la page et les valeurs affichées au bas de la page.',
          description: 'Les valeurs affichées sur le graphe du bas étaient parfois décalées de plusieurs jours par rapport aux valeurs ciblées.',
        },
      ]
    },
    {
      "version": "1.3.57",
      "date": "2020-05-18",
      "common": [
        {
          "title": "Historique des changements de responsable d'une action dans la fiche action",
          "description": "De plus, la suppression d'une action reçue depuis la page des plans d'action, renverra cette action à l'expéditeur."
        }
      ]
    },
    {
      "version": "1.3.56",
      "date": "2020-05-11",
      "common": [
        {
          "title": "Affichez l'impact des problèmes dans les graphes des indicateurs",
          "description": "@:(message.INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT_HINT). Rendez-vous dans les Paramètres > @:message.SETTINGS_INDICATORS > @:message.INDIC_SETTINGS_DISPLAY_PROBLEMS_IMPACT"
        },
        {
          "title": "Le widget Images est maintenant compatible avec plusieurs autres formats (.gif, .pdf, ...)",
          "description": ""
        }
      ]
    },
    {
      "version": "1.3.55",
      "date": "2020-05-04",
      "essential": [
        {
          "title": "Choisissez les indicateurs visibles de vos pages d'indicateurs",
          "description": "Pour modifier en direct les indicateurs affichés sur votre page indicateurs, vous pouvez simplement utiliser le bouton en bas à droite de la page et cliquer sur \"@:message.HIDE_SOME_INDICATORS\". Vous pouvez également paramétrer vos pages. Par exemple, pour paramétrer une page ne contenant que des indicateurs long-terme :<ul><li>Rendez vous dans les paramètres > @:message.SETTINGS_MAIN > @:(message.NAVIGATION_MENU).</li><li>Cliquez sur \"@:message.ADD_A_LINK\" et choisissez la page Indicateurs.</li><li>Cliquez ensuite sur \"@:message.CHOOSE_SETTINGS\", Vous retrouvez alors la même option que sur la page des indicateurs et vous pouvez cocher les indicateurs que vous ne souhaitez pas voir dans votre page long-terme.</li><li>Vous pouvez également choisir une configuration long-terme en cliquant sur \"@:message.IDC_CHART\".</li></ul>Enfin, n'hésitez pas à reproduire la même procédure pour vos étapes de réunions."
        }
      ],
      "common": [
        {
          "title": "Les actions existantes peuvent maintenant être rattachées à un problème",
          "description": "Depuis la fiche action, cliquez sur le champ \"Problème\" en haut à droite et cliquez simplement sur un problème de la liste pour y rattacher l'action."
        },
        {
          "title": "Ajout de la date de version dans la fenêtre d'informations des mises à jour",
          "description": "Vous pouvez à présent savoir à quelle date une fonctionnalité est apparue en affichant la fenêtre des notes de mises à jour"
        },
        {
          "title": "La fenêtre d'informations sur les mises à jour est accessible depuis les notifications",
          "description": "Pour l'ouvrir, cliquez sur l'icône de notification en haut à droite de Shizen, puis cliquez sur \"@:release.ALL_RELEASE_NOTES\""
        },
        {
          "title": "Les calendriers affichés pour le choix des dates affichent maintenant le lundi comme premier jour de la semaine si l'équipe a paramétré son compte en Français",
          "description": "Pour changer la langue, rendez vous dans les paramètres > @:message.SETTINGS_MAIN > @:message.LANGUAGE (ou Language) et choisissez la langue."
        },
        {
          "title": "La date de création d'un problème est maintenant éditable",
          "description": "Pour la modifier, rendez vous sur la fiche problème, et cliquez sur la date de création en haut de la section \"Problème\""
        }
      ],
      "bugs": [
        {
          "title": "Correction de l'affichage des options de la page Indicateurs dans les paramètres des étapes de réunions"
        }
      ]
    },
    {
      "version": "1.3.54",
      "date": "2020-04-27",
      "essential": [
        {
          "title": "Informations sur les mises à jour et leur contenu",
          "description": "Vous avez maintenant accès au contenu des mises à jour via la présente fenêtre. Cliquez sur \"@:release.SHOW_ALL_NOTES\" pour accéder à plus d'informations sur les dernières mises à jour. De plus, si vous avez décidé de cacher cette fenêtre, vous retrouverez ces informations depuis les paramètres > @:message.SETTINGS_MAIN > @:release.RELEASE_NOTES"
        }
      ],
      "common": [
        {
          "title": "Ajout du champ \"lieu\" lors d'une remontée de problème avancée",
          "description": "Ce champ correspond au lieu de la remontée simplifiée et de la fiche problème."
        },
        {
          "title": "Les lettres \"S\" et \"A\" des actions et des problèmes envoyés ont été remplacées par une icône",
          "description": "L'icône permet d'avoir un rendu homogène pour l'ensemble des données envoyées entre les équipes."
        }
      ],
      "bugs": [
        {
          "title": "Certaines actions n'apparaissaient pas dans les archives lorsqu'elles étaient terminées"
        }
      ]
    },
    {
      "version": "1.3.53",
      "date": "2020-04-20",
      "essential": [
        {
          "title": "Édition de l’objectif des indicateurs depuis la saisie d’indicateur",
          "description": "Pour modifier un objectif, vous pouvez maintenant accéder directement à votre page de saisie d'indicateurs, et cliquer sur l'objectif pour en modifier la valeur."
        }
      ],
      "common": [
        {
          "title": "Amélioration du chargement des problèmes similaires",
          "description": "Les problèmes sont chargés par groupes pour ne pas surcharger l'affichage. De plus, lorsque vous cochez un problème, ce dernier est déplacé en haut de la liste à l'aide d'une animation visuelle."
        },
        {
          "title": "Ajout d’un logo visuel pour les actions en retard",
          "description": "Une nouvelle image permet aux utilisateurs de mettre en avant les actions en retard. Cela permet également aux personnes atteintes d'un handicap visuel de mieux distinguer la différence entre une action en retard et une action presque terminée."
        }
      ],
      "bugs": [
        {
          "title": "Correction de bugs d’affichage de Néo dans les fiches problème et la page des indicateurs"
        }
      ]
    },
    {
      "version": "1.3.50",
      "date": "2020-04-06",
      "common": [
        {
          "title": "Affichage du nom du responsable de l’action dans un plan « support »"
        },
        {
          "title": "Affichage d’un message « Problème enregistré » lors de l’édition d’une fiche problème"
        }
      ],
      "bugs": [
        {
          "title": "Correction de l’affichage de la bulle de commentaire sur les graphes des indicateurs"
        },
        {
          "title": "Correction de l’affichage des causes dans la fiche problème et le 5 Pourquoi"
        }
      ]
    }
  ]
}

export default release;
